import { version } from 'package.json';
import { LogLevel } from '../log-level';
import { LogFormatter } from '../log-publisher';

interface RUMLog {
  '@timestamp': string;
  appName: string;
  version: string;
  context?: object;
  level: string;
  brut: string;
  message: string;
  stacktrace: string;
}

const levelMap = {
  [LogLevel.EMERG]: 'emerg',
  [LogLevel.ALERT]: 'alert',
  [LogLevel.CRIT]: 'crit',
  [LogLevel.ERROR]: 'err',
  [LogLevel.WARN]: 'warn',
  [LogLevel.NOTICE]: 'notice',
  [LogLevel.INFO]: 'info',
  [LogLevel.DEBUG]: 'debug'
};

/**
 * Log formatter for production and staging.
 * From http://wiki.tech.vestiairecollective.com/display/itdoc/Logging
 */
export const lomFormatter: LogFormatter = record => {
  const log: RUMLog = {
    '@timestamp': record.date.toISOString(),
    appName: 'ngx-web',
    version,
    level: levelMap[record.level],
    context: record.context,
    brut: record.message,
    message: record.message,
    stacktrace: ''
  };
  return JSON.stringify(log);
};
